import React from 'react';
import { Collapse } from 'antd';

const RemovedOutliersMultivariate = (props) => {
    const { Panel } = Collapse;

    let removedOutliers;
    let countLower;
    let countUpper;


    if (props.getAnalysisRes?.autoregressionx) {
        removedOutliers = props.getAnalysisRes.autoregressionx.outliers_removed;
        countLower = props.getAnalysisRes.autoregressionx.outliers_removed.lower_count
        countUpper = props.getAnalysisRes.autoregressionx.outliers_removed.upper_count
    }

    if (props.getAnalysisRes?.regression) {
        removedOutliers = props.getAnalysisRes.regression.outliers_removed;
        countLower = props.getAnalysisRes.regression.outliers_removed.lower_count
        countUpper = props.getAnalysisRes.regression.outliers_removed.upper_count
    }

    if (props.getAnalysisRes?.robust_regression) {
        removedOutliers =
            props.getAnalysisRes.robust_regression.outliers_removed;
            countLower = props.getAnalysisRes.robust_regression.outliers_removed.lower_count
        countUpper = props.getAnalysisRes.robust_regression.outliers_removed.upper_count
    }

    if (props.getAnalysisRes?.scatterplot) {
        removedOutliers = props.getAnalysisRes.scatterplot.outliers_removed;
        countLower = props.getAnalysisRes.scatterplot.outliers_removed.lower_count
        countUpper = props.getAnalysisRes.scatterplot.outliers_removed.upper_count
    }
    if (props.getAnalysisRes?.robust_scatterplot) {
        removedOutliers = props.getAnalysisRes.robust_scatterplot.outliers_removed;
        countLower = props.getAnalysisRes.robust_scatterplot.outliers_removed.lower_count
        countUpper = props.getAnalysisRes.robust_scatterplot.outliers_removed.upper_count
    }
    if (props.getAnalysisRes?.weighted_scatterplot) {
        removedOutliers = props.getAnalysisRes.weighted_scatterplot.outliers_removed;
        countLower = props.getAnalysisRes.weighted_scatterplot.outliers_removed.lower_count
        countUpper = props.getAnalysisRes.weighted_scatterplot.outliers_removed.upper_count
    }

    console.log(`removedOutliers`, removedOutliers);

    let outliersLower = removedOutliers.lower;
    let outliersUpper = removedOutliers.upper;

    // let outliersUpperMap;
    // if (outliersUpper.length !== 0) {
    //     outliersUpperMap = Object.values(outliersUpper).map(
    //         (item) => {
    //             return (
    //                 <tr key={item[0] + item[1] + 'cba'}>
    //                     <td>{item[0]}</td>
    //                     <td>{item[1]}</td>
    //                 </tr>
    //             );
    //         }
    //     );
    // } else {
    //     outliersUpperMap = (
    //         <tr>
    //             <td>-</td>
    //             <td>-</td>
    //         </tr>
    //     );
    // }

    // let upperTableTest = (
    //     <>
    //         <div className="removed-outliers-container">
    //             <div className="title">Upper Outliers</div>
    //             <table className="table-rm-out">
    //                 <thead>
    //                     <tr>
    //                         <td>Row</td>
    //                         <td>Value</td>
    //                     </tr>
    //                 </thead>
    //                 <tbody>{outliersUpperMap}</tbody>
    //             </table>
    //         </div>
    //     </>
    // );

    // let outliersLowerMap;
    // if (outliersLower.length == 0) {
    //     outliersLowerMap = (
    //         <tr>
    //             <td>-</td>
    //             <td>-</td>
    //         </tr>
    //     );
    // } else {
    //     outliersLowerMap = Object.values(outliersLower).map(
    //         (item) => {
    //             return (
    //                 <tr key={item[0] + item[1] + 'abc'}>
    //                     <td>{item[0]}</td>
    //                     <td>{item[1]}</td>
    //                 </tr>
    //             );
    //         }
    //     );
    // }

    // let lowerTableTest = (
    //     <>
    //         <div className="removed-outliers-container">
    //             <div className="title">Lower Outliers</div>
    //             <table className="table-rm-out">
    //                 <thead>
    //                     <tr>
    //                         <td>Row</td>
    //                         <td>Value</td>
    //                     </tr>
    //                 </thead>
    //                 <tbody>{outliersLowerMap}</tbody>
    //             </table>
    //         </div>
    //     </>
    // );

    const hasRatio = removedOutliers.has_ratio;
    const yName = removedOutliers.y_display_name || 'Y';
    const x1Name = removedOutliers.x1_display_name || 'X';
    const ratioName = `${yName} / ${x1Name}`;

    const buildTable = (items, title, count) => {
        if (items.length === 0) {
            return (
                <div className="removed-outliers-container">
                    <div className="title">{title} {`(${count})`}</div>
                    <table className="table-rm-out">
                        <tbody>
                            <tr><td>-</td></tr>
                        </tbody>
                    </table>
                </div>
            );
        }

        if (hasRatio) {
            // Extended format: [Id, Y1, X1, ratio]
            return (
                <div className="removed-outliers-container">
                    <div className="title">{title} {`(${count})`}</div>
                    <table className="table-regression">
                        <thead>
                            <tr>
                                <th>Row</th>
                                <th>{yName}</th>
                                <th>{x1Name}</th>
                                <th>{ratioName}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{item[0]}</td>
                                    <td>{item[1]}</td>
                                    <td>{item[2]}</td>
                                    <td>{item[3]}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        // Legacy format: [Id, Y1]
        return (
            <div className="removed-outliers-container">
                <div className="title">{title} {`(${count})`}</div>
                <table className="table-rm-out">
                    <tbody>
                        <tr>
                            <td>Row</td>
                            {items.map((item, idx) => <td key={idx}>{item[0]}</td>)}
                        </tr>
                        <tr>
                            <td>Value</td>
                            {items.map((item, idx) => <td key={idx}>{item[1]}</td>)}
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    let upperTableTest = buildTable(outliersUpper, 'Upper Outliers', countUpper);
    let lowerTableTest = buildTable(outliersLower, 'Lower Outliers', countLower);

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel
                    key={1}
                    header={`Removed Outliers`}
                    // showArrow={false}
                    id="id-remove-outliers"
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div
                            style={{
                                width: '100%',
                                marginBottom: 30
                            }}
                        >
                            {lowerTableTest}
                        </div>

                        <div
                            style={{
                                width: '100%'
                            }}
                        >
                            {upperTableTest}
                        </div>
                    </div>
                </Panel>
            </Collapse>
        </>
    );
};

export default React.memo(RemovedOutliersMultivariate);
// export default RemovedOutliers;
